//
//
//
//
//
//
//

// import FlowSteps from "@/0/components/comStockOrder/comFlowSteps.vue";
import PowerScanner from "@/0/components/comStockOrder/comPowerScanner.vue";
import FooterButtonList from "@/0/components/comStockOrder/comFooterButtonList.vue";

var tmpProductSnList = [];
export default {
  components: {
    // "flow-steps": FlowSteps,
    "power-scanner": PowerScanner,
    "footer-button-list": FooterButtonList,
  },

  data() {
    //这里存放数据
    return {

      flowStepsConfig: {
        bg: "#fff",
        padding: "15px 40px",
        size: "30px",
        numberSize: "18px",
        textSize: "",
        textTop: "30px",
        lineWidth: "3px",
        list: [
          { number: 1, text: "创建盘库单", isDone: true },
          { number: 2, text: "盘库扫码", isDone: true },
          { number: 3, text: "盘库结束", isActive: false, isDone: false }
        ]
      },

      powerScannerConfig: {
        StockOrderType: 2
      },

      buttonListConfig: {
        btnL: {
          text: "返回",
          action: () =>
            wx.navigateBack({
              delta: 1
            })
        },
        btnR: {
          text: "提交",
          action: () => {
            this.$submitOrder();
          }
        },
        btnScanCode: {
          action: () => {
            this.$refs.comPowerScanner.$openScan();
            return;
          }
        },
        
        desc: "扫一扫极速盘库"
      }
    };
  },
  
  async created() {
    var oaOpenId = "225a333b35c96e744552faa68baad896";
    await this.$wx.initOaConfig(oaOpenId, () => {

      this.$wx.hideAllNonBaseMenuItem();
      console.log("初始化成功");

    });
  },

  async mounted() {
    this.$refs.comPowerScanner.$refreshUI();
  },
  //方法集合
  methods: {

    $getSubmitData(){
      var formData = this.$refs.comPowerScanner.$getSubmitData();
      return formData;      
    },

    async submitOrder(endUrl) {
      this.$msg.confirm("您是否确定要提交？", async () => {
        // this.$router.push({ path: "/Sms/ShopStockInBuyOrder/End" });
        this.$msg.showLoading("正在提交...");
        var result = await this.$getSubmitData();

        this.$msg.hideLoading();
        if (result.state == 1) {
          this.$msg.succ(result.msg);
          if (endUrl) {
            endUrl += "?openId=" + result.data.OpenId;
            this.$path.to(endUrl);
            //this.$router.push({ path: endUrl });
          }
          return;
        }
        this.$msg.alert(result.msg);
      });
    },

    GetScanCode(){

    },

  },
};
